import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b0974d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex text-white justify-center w-full items-center mt-6"
}
const _hoisted_2 = { class: "md:h-[200px] h-[160px] md:w-[90%] sx:w-full exp flex justify-center items-center pr-24 sx:pr-[10px] rounded-r-full backdrop-filter backdrop-blur-sm bg-opacity-10" }
const _hoisted_3 = { class: "w-1/2 h-auto flex flex-col text-left md:p-5 p-4" }
const _hoisted_4 = { class: "md:text-[14px] text-[12px]" }
const _hoisted_5 = { class: "md:text-[14px] text-[12px]" }
const _hoisted_6 = ["src", "alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.type === 'actions')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString($props.title), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString($props.action), 1)
          ]),
          _createElementVNode("img", {
            src: $props.src,
            alt: _ctx.alt,
            class: "w-1/2 sx:w-[40%] h-full right-[20%] sx:right-[0%] sx:rounded-r-full object-cover"
          }, null, 8, _hoisted_6)
        ])
      ]))
    : _createCommentVNode("", true)
}